import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../utils/Api";
import StaticFunctions from "../utils/StaticFunctions";

import './LoginPage.css';

class ForgotPasswordPage extends Component {

    static propTypes = {
        mail: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired,
        languages: PropTypes.array.isRequired,
        translate: PropTypes.func.isRequired,
        zskLinks: PropTypes.object.isRequired,
        i18n: PropTypes.object.isRequired,
        setUrlStateParams: PropTypes.func.isRequired,
    };

    componentWillMount() {

        this.handleAuthRequest();

    }

    constructor(props) {

        super(props);

        this.state = {};

        this.api = new Api();

        this.translate = this.props.translate;

        this.focusValidatePassword = this.focusValidatePassword.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);

    }

    handleAuthRequest() {

        const params = {
            action: 'auth',
            email: this.props.mail,
            auth: this.props.code
        };

        const callback = function(res) {
            if (res !== true) {
                this.props.setUrlStateParams();

                window.location.href = window.location.href.split("?")[0];
            }
        }.bind(this);

        this.api.request('RequestForgotPassword', params, callback, null);

    }

    handleResetRequest() {

        const password = document.getElementById('password').value;
        const confirmPassword = document.getElementById('validatePassword').value;
        const validatePassword = StaticFunctions.validatePassword(password, confirmPassword);

        if (validatePassword === true) {
            const params = {
                action: 'resetPassword',
                email: this.props.mail,
                auth: this.props.code,
                password: password
            };

            const callback = function (res) {
                if (res === true) {
                    alert(this.translate('resetedPassword'));

                    this.props.setUrlStateParams();
                } else {
                    alert(this.translate('errorOccured'));
                }
            }.bind(this);

            this.api.request('RequestForgotPassword', params, callback, null);
        } else {
            alert(this.translate(validatePassword));
        }

    }

    focusValidatePassword(event) {

        if (event.key === "Enter" && this.refValidatePassword) this.refValidatePassword.focus();

    }

    handleKeyPress(event) {

        if (event.key === "Enter") this.handleResetRequest();

    }

    changeLanguage(event) {

        if (event) {
            const selectedLanguage = event.target.value;

            this.selectedLanguage = selectedLanguage;
            this.props.i18n.changeLanguage(selectedLanguage);
        }

    }

    getLanguageOptions() {

        const languages = this.props.languages;

        return languages.map(
            (language, index) => {
                return (
                    <option key={'option-' + index} value={language.value}>{language.label}</option>
                );
            }
        );

    }

    render() {

        const options = this.getLanguageOptions();

        const zskUrl = this.props.zskLinks.homePage;
        const zskHomePage = zskUrl + ((this.selectedLanguage === 'de') ? '/de' : '/en') ;
        const zskImprintLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.imprint;
        const zskPolicyLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.policy;
        const zskConditionLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.condition;

        return (
            <div>
                <div>
                    {/*<!-- BG Teaser + Verläufe -->*/}
                    <div id="MyTeaser" style={{display: 'block'}}>&nbsp;</div>
                    <div id="gradients" style={{display: 'block'}}>&nbsp;</div>
                    {/*<!-- / BG Teaser + Verläufe -->*/}

                    <header style={{display: 'block'}}>My.ZSK</header>

                    <div className="formdata">
                        <div>
                            <h1>{this.translate('resetPassword')}</h1>

                            <table className="firstTr40" style={{width: '100%'}}>
                                <tbody>
                                    <tr>
                                        <td className="text-left">{this.translate('email')}</td>

                                        <td className="text-left">
                                            <input
                                                id="mainUserMail"
                                                className="input__field"
                                                type="text"
                                                value={this.props.mail}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left" style={{minWidth: '100px'}}>{this.translate('password')}</td>

                                        <td className="text-left">
                                            <input
                                                id="password"
                                                className="input__field"
                                                type="password"
                                                autoFocus={true}
                                                onKeyDown={this.focusValidatePassword}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left" style={{minWidth: '100px'}}>{this.translate('validatePassword')}</td>

                                        <td className="text-left">
                                            <input
                                                id="validatePassword"
                                                className="input__field"
                                                type="password"
                                                onKeyDown={this.handleKeyPress}
                                                ref={(input) => this.refValidatePassword = input}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left" style={{minWidth: '100px'}}>{this.translate('language')}</td>

                                        <td className="text-left selbox">
                                            <div className="lang-select">
                                                <div id="ddArr" className="arrow">&nbsp;</div>

                                                <select id="langselector" value={this.selectedLanguage} onChange={(event) => this.changeLanguage(event)}>
                                                    {options}
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div>
                            <div className="clearfix" style={{borderBottom: '2px solid #fff', marginBottom: 10}}>
                                <div className="submitmsgcontainer">
                                    <div className="clearfix">
                                        <div className="buttonFrame flr">
                                            <input type="button" onClick={() => this.handleResetRequest()} value={this.translate('reset')}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="noteBox">{this.translate('changePasswordNoteText')}</div>

                        <div>
                            <ul>
                                <li>{this.translate('changePasswordNote1')}</li>
                                <li>{this.translate('changePasswordNote2')}</li>
                                <li>{this.translate('changePasswordNote3')}</li>
                                <li>{this.translate('changePasswordNote4')}</li>
                            </ul>
                        </div>
                    </div>

                    <footer style={{display: 'block'}}>
                        <div className="rt">
                            <p>
                                <a href={zskHomePage} target="_blank" rel="noopener noreferrer">www.zsk.de</a>
                                |
                                <a href={zskConditionLink} target="_blank" rel="noopener noreferrer">{this.translate('termsAndConditions')}</a>
                                |
                                <a href={zskPolicyLink} target="_blank" rel="noopener noreferrer">{this.translate('privacyPolicy')}</a>
                                |
                                <a href={zskImprintLink} target="_blank" rel="noopener noreferrer">{this.translate('imprint')}</a>
                            </p>
                        </div>

                        <div className="mig">Made in Germany</div>
                    </footer>
                </div>

                <style dangerouslySetInnerHTML={{__html: `#atlwdg-trigger {display : none;}`}}/>
            </div>
        );

    }

}

export default ForgotPasswordPage;